// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.process-block {
    display: flex;
    align-items: center;
    gap: 2rem;
    padding: 2rem 0;
}

.process-block.reverse {
    flex-direction: row-reverse;
}

.process-content {
    flex: 1 1;
}

.process-content h3 {
    color: var(--admin-color);
    margin-bottom: 1rem;
    font-size: 1.8rem;
}

.process-content p {
    color: var(--text-color);
    margin-bottom: 1.5rem;
    line-height: 1.6;
}

.process-image {
    flex: 1 1;
    text-align: center;
}

.process-image img {
    max-width: 100%;
    height: auto;
    border-radius: var(--border-radius);
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.process-btn {
    background: var(--admin-color);
    color: white;
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: var(--border-radius);
    cursor: pointer;
    font-weight: 500;
    transition: background-color 0.3s ease;
}

.process-btn:hover {
    background: var(--button-hover-color);
}

.empty-image {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 200px;
    background: var(--background-color);
    border: 2px dashed var(--border-color);
    border-radius: var(--border-radius);
    color: var(--text-color);
    opacity: 0.6;
}

.empty-image .mdi {
    font-size: 3rem;
    margin-bottom: 1rem;
}

.empty-image p {
    margin: 0;
    font-size: 0.9rem;
}
`, "",{"version":3,"sources":["webpack://./src/Components/HomePage/ProcessBlock/ProcessBlock.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,mCAAmC;IACnC,qCAAqC;AACzC;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,mCAAmC;IACnC,eAAe;IACf,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,mCAAmC;IACnC,sCAAsC;IACtC,mCAAmC;IACnC,wBAAwB;IACxB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,iBAAiB;AACrB","sourcesContent":[".process-block {\n    display: flex;\n    align-items: center;\n    gap: 2rem;\n    padding: 2rem 0;\n}\n\n.process-block.reverse {\n    flex-direction: row-reverse;\n}\n\n.process-content {\n    flex: 1;\n}\n\n.process-content h3 {\n    color: var(--admin-color);\n    margin-bottom: 1rem;\n    font-size: 1.8rem;\n}\n\n.process-content p {\n    color: var(--text-color);\n    margin-bottom: 1.5rem;\n    line-height: 1.6;\n}\n\n.process-image {\n    flex: 1;\n    text-align: center;\n}\n\n.process-image img {\n    max-width: 100%;\n    height: auto;\n    border-radius: var(--border-radius);\n    box-shadow: 0 4px 8px rgba(0,0,0,0.1);\n}\n\n.process-btn {\n    background: var(--admin-color);\n    color: white;\n    border: none;\n    padding: 0.75rem 1.5rem;\n    border-radius: var(--border-radius);\n    cursor: pointer;\n    font-weight: 500;\n    transition: background-color 0.3s ease;\n}\n\n.process-btn:hover {\n    background: var(--button-hover-color);\n}\n\n.empty-image {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 200px;\n    background: var(--background-color);\n    border: 2px dashed var(--border-color);\n    border-radius: var(--border-radius);\n    color: var(--text-color);\n    opacity: 0.6;\n}\n\n.empty-image .mdi {\n    font-size: 3rem;\n    margin-bottom: 1rem;\n}\n\n.empty-image p {\n    margin: 0;\n    font-size: 0.9rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
